<template>
  <div class="introduction">
    <div style="width: 100%;height: 100%">
      <div ref="mySwiper" class="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="sliderPage">
              <div class="img">
                <img src="https://seaweedfs.uidashi.com/93,2acd0539789e7d.png" alt="">
              </div>
              <div class="title">
                <div class="title1">快速登录 导入词库</div>
                <div class="title2">一键导入原有输入法词库，供机器学习智能推荐您更想用的词汇</div>
                <div class="title2">操作方式：注册登录→设置→个人设置→导入词库</div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="sliderPage sliderPageSelf">
              <div class="img">
                <img src="https://seaweedfs.uidashi.com/97,2acd040b849b26.png" alt="">
              </div>
              <div class="title">
                <div class="title1">本地文库 自动推送</div>
                <div class="title2">自助设置本机文库，在输入过程中自动推送匹配的写作参考内容<br/>
                  操作方式：注册登录→设置→本机文库→授权文件夹→已授权文件夹
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="sliderPage sliderPageSelf">
              <div class="img">
                <img src="https://seaweedfs.uidashi.com/95,2acd18a71137c6.png" alt="">
              </div>
              <div class="title">
                <div class="title1">高效检索 一键上屏</div>
                <div class="title2">在打字过程一键检索各类可用文库中匹配的内容，可一键展开原文并复选多段快速输入文字</div>
                <div class="title2">
                  <span style="display:inline-block;margin-bottom: 10px">操作方式：具有<span style="color: red">▼</span>的候选词，可Ctrl+编号数字 或Tab键 检索各类文库的关联文章</span>
                  <br/>* 左右键 或 -= 进行翻页查看，
                  <br/>* 点击左侧编号字母则句子直接输入，
                  <br/>* 点击右侧编号字母则展开正文，
                  <br/>* Shift+上下键可选择多段，
                  <br/>* 按空格键多段输入。
                </div>
                <br/>
                <div class="notice">注：具体操作可根据输入法界面上橘红色字体的 <span class="zhu">注</span> 提示信息进行</div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="sliderPage">
              <div class="img">
                <img src="https://seaweedfs.uidashi.com/95,2acd0b857f42a6.png" alt="">
              </div>
              <div class="title">
                <div class="title1">智能搜索 热键直达</div>
                <div class="title2">本机算力辅助多维搜索本地全文和内外网资讯，交叉比对和验证后呈现的搜索结果更优质<br/>
                  操作方法：默认唤起热键为 Ctrl+Shift+Z <span style="font-size: 15px;">（注:按住Ctrl键和Shift键的同时点击Z）</span>
                </div>
                <br/>
                <div class="notice">注：登录后可自定义其他热键唤起智能搜索</div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="sliderPage">
              <div class="img">
                <img src="https://seaweedfs.uidashi.com/76,2acd02e0cb0af4.png" alt="">
              </div>
              <div class="title">
                <div class="title1">单位文库 拟文规范</div>
                <div class="title2">单位后台可自建单位文库，方便同事拟文写作参考，引用来源更规范可靠。</div>
                <br/>
                <div class="notice">注：同事有优质范文，也可一键自助贡献到单位文库与同事分享</div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="sliderPage">
              <div class="img">
                <img src="https://seaweedfs.uidashi.com/95,2acd0a54e3bef1.png" alt="">
              </div>
              <div class="title">
                <div class="title1">私有部署 隐私计算 更安全</div>
                <div class="title2">
                  隐私计算数据可用不可见，办公系统独立部署在自有服务器，信息才更安全。<br/>
                  个人版、单位版、SaaS租户版均支持完整系统程序的独立部署，不给偷窥者留机会。
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="sliderPage">
              <div class="img">
                <img src="https://seaweedfs.uidashi.com/91,2acd012e66abe9.png" alt="">
              </div>
              <div class="title">
                <div class="title1">永无弹窗 极致专注 更纯粹</div>
                <div class="title2">没有烦人的弹窗广告，杜绝骚扰卡顿，专心写作。</div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper';
  import 'swiper/css/swiper.css';

  export default {
    name: "introduction",
    mounted() {
      this.initSwiper();
    },
    data() {
      return {
        currentSwiper: '',
        activeIndex: 0,
      }
    },
    methods: {
      initSwiper() {
        let that = this;
        this.currentSwiper = new Swiper('.swiper', {
          speed: 400,
          spaceBetween: 0,
          mousewheel: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          on: {
            slideChangeTransitionEnd: function () {
              that.activeIndex = this.activeIndex;
            }
          }
        })
      },
      goToPage(index) {
        this.activeIndex = index;
        this.currentSwiper.slideTo(index, 300, false)
      },
    }
  }
</script>

<style scoped lang='less'>
  .introduction {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow-y: hidden;
    position: relative;
    margin: 0 auto;

    .swiper {
      width: 100%;
      overflow: hidden;

      .swiper-wrapper {
        height: 100%;

        .swiper-slide {
          width: 100%;
          height: 100%;
        }
      }
    }

    .sliderPage {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      padding: 10% 10%;
      box-sizing: border-box;
      display: flex;

      .img {
        width: 30%;

        img {
          width: 100%;
        }
      }

      .title {
        width: 65%;
        margin-left: 5%;
      }

      .title1 {
        font-size: 36px;
        font-weight: bolder;
        line-height: 60px;
        margin-bottom: 20px;
        color: rgb(75, 73, 72);
      }

      .title2 {
        font-size: 18px;
        line-height: 30px;
        color: #868686;
      }

      .notice {
        font-size: 15px;
        line-height: 20px;
        color: #868686;

        .zhu {
          color: rgb(255, 128, 74);
          border: 1px solid rgb(255, 128, 74);
          border-radius: 50%;
          box-sizing: border-box;
          width: 20px;
          height: 20px;
          font-size: 14px;
          line-height: 18px;
          text-align: center;
          display: inline-block;
        }
      }
    }

    .sliderPageSelf {
      .img {
        width: 40%;
      }

      .title {
        width: 55%;
        margin-left: 5%;
      }
    }
  }
</style>
